import { FC, useEffect, useState, useMemo } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Formik, useFormik } from "formik";
import { useSelector } from "react-redux";
import { t } from "i18next";

import { faAt, faPhone } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { InputWithLeadingIcon } from "@/shared/components/atoms/InputWithLeadingIcon";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { SelectCountry } from "@/shared/components/organisms/SelectCountry";
import TableListUsers from "@/shared/components/organisms/TableListUsers";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { CreateUserModal } from "@/pages/InformationUserPages/Components/CreateUser";
import { InputFile } from "@/shared/components/atoms/InputFile";
import { Select } from "@/shared/components/organisms/Select";
import { Modal } from "@/shared/components/organisms/Modal";
import { toasts } from "@/shared/utils/toasts";

import { QueryMetaData } from "@/app/gyms/gyms";

import { useGetAllStatesQuery } from "@/app/app.apiStates";

import {
  useTagMarketingQuery,
  useTrainingCreatedByQuery,
  useNutritionCreatedByQuery,
} from "@/app/users/users.api";

import { useCoursesQuery, useCoursesFeeQuery } from "@/app/courses/courses.api";

import { useGetAllCountriesQuery } from "@/app/app.apiCountry";

import {
  useStoreUserMutation,
  useFetchUsersMutation,
  useLazyExportUsersQuery,
  useStateUserMutation,
} from "@/app/users/users.api";
import { useFeesMutation } from "@/app/fees/fees.api";
import { useBondsQuery } from "@/app/bonds/bonds.api";
import { useRolesQuery } from "@/app/roles/roles.api";
import { useGetBranchQuery } from "@/app/branchs/branchs.api";
import { useGymsByAccessUserQuery } from "@/app/gyms/gyms.api";
import { useFetchBranchsMutation } from "@/app/branchs/branchs.api";
import { useSlotBondsQuery } from "@/app/slot-bonds/slot-bonds.api";

import {
  userInitialValues,
  userValidationSchema,
} from "@/shared/schemas/users.schema";

import { selectUser } from "@/app/auth/auth.slice";

const optionsStatus = [
  { id: 1, name: "Todos" },
  { id: 2, name: "Activos" },
  { id: 3, name: "Inactivos" },
];

export const ListUser: FC<any> = () => {
  const user = useSelector(selectUser);
  const [gymId, setgymId] = useState(0);
  const [branchId, setBranchId] = useState(0);
  const [optionsGyms, setOptionsGyms] = useState([]);
  const [optionsBranchs, setOptionsBranchs] = useState([]);
  const [openModalCodeQR, setOpenModalCodeQR] = useState(false);

  useEffect(() => {
    if (user && user?.branch) {
      setBranchId(user?.branch?.id);
    }
  }, [user]);

  //OPCIONES FILTERS
  const optionsSex = [
    { id: "Hombre", name: t("user.views.man") },
    { id: "Mujer", name: t("user.views.female") },
  ];

  const optionsInfoPago = [
    { id: "active", name: t("fees.views.fee_active") },
    { id: "delayed", name: t("fees.views.state_payment_delay") },
    { id: "unsubscribe", name: t("fees.views.state_payment_low_2") },
    { id: "finished", name: t("fees.views.rejected_payment") },
  ];
  const optionsMultiCentros = [
    { id: 1, name: t("general.yes") },
    { id: 0, name: t("general.no") },
  ];
  const optionsEval = [
    { id: 2, name: t("user.views.<1") },
    { id: 3, name: t("user.views.<3") },
    { id: 4, name: t("user.views.<5") },
    { id: 5, name: t("user.views.<7") },
  ];

  //FIN OPCIONS FILTERS
  const [selectedGyms, setSelectedGyms] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [selectedBranchs, setSelectedBranchs] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<{
    id: string;
    name: string;
  } | null>(null);

  const filterFormik = useFormik({
    initialValues: {
      sex: "",
      country: "",
      initialAge: 0,
      finalAge: 100,
      payFee: "",
      payCourse: "",
      multiCenter: undefined,
      cuotas: undefined,
      feesCourses: "",
      courses: "",
      bonds: "",
      spaceBonuses: "",
      lest: undefined,
      trainingCreatedBy: undefined,
      nutritionCreatedBy: undefined,
      userTags: [],
      marketingTags: [],
    },
    onSubmit: () => {},
  });

  const [open, setOpen] = useState(false);
  const [openOneDay, setOpenOneDay] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const handleOpenFilters = () => setOpenFilters(!openFilters);
  //const [branchSelected, setBranchSelected] = useState(undefined);

  const branchsQuery = useGetBranchQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const branchSelected = useMemo(() => {
    return branchsQuery.data;
  }, [branchsQuery]);

  const rolesQuery = useRolesQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const roleOptions = useMemo(() => {
    return rolesQuery.data
      ?.filter((role: any) => role.name === "Client")
      .map((role: any) => ({
        id: role.name,
        name: role.name,
      }));
  }, [rolesQuery]);

  // Cuotas
  const [getterFees, getterFeesResult] = useFeesMutation();

  useEffect(() => {
    if (branchId) {
      getterFees({
        branchId: branchId,
      });
    }
  }, [branchId]);

  const optionsCoutas = useMemo(() => {
    return getterFeesResult.data
      ? getterFeesResult.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [getterFeesResult]);

  // Cuotas curso
  const courseFeesQuery = useCoursesFeeQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionscoutasCursos = useMemo(() => {
    return courseFeesQuery.data
      ? courseFeesQuery.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [courseFeesQuery]);

  // Cursos
  const coursesQuery = useCoursesQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionsCursos = useMemo(() => {
    return coursesQuery.data
      ? coursesQuery.data.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [coursesQuery]);

  // Bonos
  const bondsQuery = useBondsQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionsBonosSP = useMemo(() => {
    return bondsQuery.data
      ? bondsQuery.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [bondsQuery]);

  // Bonos espacio
  const slotBondsQuery = useSlotBondsQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionsBonosEspa = useMemo(() => {
    return slotBondsQuery.data
      ? slotBondsQuery.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [slotBondsQuery]);

  // Training created by
  const trainingCreatedByQuery = useTrainingCreatedByQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionTraiginCreateBy = useMemo(() => {
    return trainingCreatedByQuery.data
      ? trainingCreatedByQuery.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [trainingCreatedByQuery]);

  // Nutrition created pby
  const nutritionCreatedByQuery = useNutritionCreatedByQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionsNutrition = useMemo(() => {
    return nutritionCreatedByQuery.data
      ? nutritionCreatedByQuery.data.map((role: any) => ({
          id: role.id,
          name: role.name,
        }))
      : [];
  }, [nutritionCreatedByQuery]);

  // Nutrition created pby
  const tagMarketingQueryQuery = useTagMarketingQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionsUserTags = useMemo(() => {
    return tagMarketingQueryQuery.data
      ? tagMarketingQueryQuery.data
          ?.filter((role: any) => role.type === 2)
          .map((role: any) => ({
            id: role.id,
            name: role.name,
          }))
      : [];
  }, [tagMarketingQueryQuery]);

  const optionsMarketingTags = useMemo(() => {
    return tagMarketingQueryQuery.data
      ? tagMarketingQueryQuery.data
          ?.filter((role: any) => role.type === 1)
          .map((role: any) => ({
            id: role.id,
            name: role.name,
          }))
      : [];
  }, [tagMarketingQueryQuery]);

  // Final de la secuencia
  const [exportUsers, exportUsersResult] = useLazyExportUsersQuery();
  const [createUser, createUserResult] = useStoreUserMutation();
  const [changeStateUser, changeStateUserResult] = useStateUserMutation();
  const {
    data: countries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useGetAllCountriesQuery({});
  const {
    data: states,
    isLoading: isLoadingStates,
    isError: isErrorStates,
  } = useGetAllStatesQuery({});

  useEffect(() => {
    if (createUserResult.isSuccess) {
      toasts.success(
        "Registro exitoso",
        "El usuario ha sido registrado correctamente"
      );
    }

    if (createUserResult.isError) {
      toasts.danger(
        "Error al registrar",
        "Ha ocurrido un error al registrar el usuario"
      );
    }
  }, [createUserResult]);

  useEffect(() => {
    if (changeStateUserResult.isSuccess) {
      toasts.success(
        "Cambio exitoso",
        "El estado del usuario ha sido cambiado correctamente"
      );
    }

    if (changeStateUserResult.isError) {
      toasts.danger(
        "Error al cambiar",
        "Ha ocurrido un error al cambiar el estado del usuario"
      );
    }
  }, [changeStateUserResult]);

  // Mutación para obtener gyms
  const gymsByAccessUserQuery = useGymsByAccessUserQuery({});

  const [fetchBranchs] = useFetchBranchsMutation();

  useEffect(() => {
    if (user && gymsByAccessUserQuery.isSuccess) {
      let objetCompanies = {};
      const arrayCompanies = [];
      for (let i = 0; i < gymsByAccessUserQuery.data.length; i++) {
        objetCompanies = {
          id: gymsByAccessUserQuery.data[i].id,
          name: gymsByAccessUserQuery.data[i].name,
        };
        arrayCompanies.push(objetCompanies);
      }

      setgymId(user?.branch?.gymId);
      setSelectedGyms(
        arrayCompanies.find((gym) => gym?.id === user?.branch?.gymId)
      );
      setOptionsGyms(arrayCompanies);
    }
  }, [gymsByAccessUserQuery, user]);

  useEffect(() => {
    const fetchBranchsData = async () => {
      const responseBranchs = await fetchBranchs({
        limit: 100,
        gymId: gymId,
      }).unwrap();
      const arrayBranchs = [];
      let objetBranchs = {};
      for (let i = 0; i < responseBranchs.data.length; i++) {
        objetBranchs = {
          id: responseBranchs.data[i].id,
          name: responseBranchs.data[i].branch,
          gym_id: responseBranchs.data[i].gym_id,
        };
        arrayBranchs.push(objetBranchs);
      }

      if (gymId === user?.branch.gymId) {
        setSelectedBranchs(
          arrayBranchs?.find((branch) => branch?.id === user?.branch?.id)
        );
      }

      setOptionsBranchs(arrayBranchs);
    };

    if (gymId !== 0) {
      fetchBranchsData();
    }
  }, [gymId]);

  const [fetchUsers, { isError, isLoading }] = useFetchUsersMutation();
  //State para capturar lo que el usuario escribe en la barra de busqueda
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState(1);
  const [entries, setEntries] = useState(10);
  const [queryMetaData, setQueryMetaData] = useState<QueryMetaData>({
    page: 1,
    perPage: 1,
    total: 1,
    lastPage: 1,
  });

  // Función para manejar cambios de página
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };
  //STATE PARA DARLE FORMATO A LOS PAISES
  const [optionsCountryApi, setOptionsCountryApi] = useState([]);
  // STATE PARA GUARDAR EL PAIS SELECCIONADO
  const [SelectedCountry, SetSelectedCountry] = useState([]);
  //STATE PARA DARLE FORMATO A LOS EST
  const [optionsStateApi, setOptionsStateApi] = useState([]);
  const [selectedState, setSelectedState] = useState({ id: "", name: "" });

  useEffect(() => {
    // Verifica que no esté cargando y que no haya errores
    if (
      !isLoadingCountries &&
      !isErrorCountries &&
      countries &&
      countries.length > 0
    ) {
      // Mapea y transforma los datos de los países
      console.debug(countries);
      const arrayCountries = countries.map((country) => ({
        id: country.name.common,
        name: country.name.common,
        code: country.cca2,
      }));

      // agregar un país por defecto
      arrayCountries.unshift({ id: "", name: "Selecciona un país", code: "" });

      // Actualiza el estado con los países formateados
      setOptionsCountryApi(arrayCountries);

      // Selecciona el primer país por defecto, si aún no hay uno seleccionado
      if (!SelectedCountry.length) {
        SetSelectedCountry(arrayCountries[0]);
      }
    }

    // Manejamos los errores
    if (isErrorCountries) {
      console.log("ERROR EN LOS COUNTRIES");
    }
  }, [countries, isLoadingCountries, isErrorCountries]);

  const handleEntriesChange = (entries: number) => {
    setEntries(entries);
  };

  const handleExportUsers = async () => {
    if (selectedGyms === null) {
      toasts.danger("Error", "Selecciona una compañia");
      return;
    }

    if (selectedBranchs === null) {
      toasts.danger("Error", "Selecciona una filial");
      return;
    }

    exportUsers({
      branchId: selectedBranchs?.id,
      search: search.length < 1 ? undefined : search,
      page: page,
      limit: entries,
      gym:
        !selectedGyms || selectedGyms.id === null ? undefined : selectedGyms.id,
      status:
        !selectedStatus || selectedStatus.id === null
          ? undefined
          : selectedStatus.id,
      sex: filterFormik.values.sex,
      country: filterFormik.values.country.code,
      initialAge: filterFormik.values.initialAge,
      finalAge: filterFormik.values.finalAge,
      payFee: filterFormik.values.payFee,
      payCourse: filterFormik.values.payCourse,
      multiCenter: filterFormik.values.multiCenter,
      cuotas: filterFormik.values.cuotas,
      feesCourses: filterFormik.values.feesCourses,
      courses: filterFormik.values.courses,
      bonds: filterFormik.values.bonds,
      spaceBonuses: filterFormik.values.spaceBonuses,
      lest: filterFormik.values.lest,
      trainingCreatedBy: filterFormik.values.trainingCreatedBy,
      nutritionCreatedBy: filterFormik.values.nutritionCreatedBy,
      userTags: filterFormik.values.userTags,
      marketingTags: filterFormik.values.marketingTags,
    });
  };

  const [users, setUsers] = useState([]);

  //Traer datos de Users
  const fechtDatos = async () => {
    try {
      if (!selectedBranchs) return null;
      if (!selectedBranchs.id) return null;

      const response = await fetchUsers({
        search: search.length < 1 ? undefined : search,
        page: page,
        limit: entries,
        gym:
          !selectedGyms || selectedGyms.id === null
            ? undefined
            : selectedGyms.id,
        branch:
          !selectedBranchs || selectedBranchs.id === null
            ? undefined
            : selectedBranchs.id,
        status:
          !selectedStatus || selectedStatus.id === null
            ? undefined
            : selectedStatus.id,
        sex: filterFormik.values.sex,
        country: filterFormik.values.country.code,
        initialAge: filterFormik.values.initialAge,
        finalAge: filterFormik.values.finalAge,
        payFee: filterFormik.values.payFee,
        payCourse: filterFormik.values.payCourse,
        multiCenter: filterFormik.values.multiCenter,
        cuotas: filterFormik.values.cuotas,
        feesCourses: filterFormik.values.feesCourses,
        courses: filterFormik.values.courses,
        bonds: filterFormik.values.bonds,
        spaceBonuses: filterFormik.values.spaceBonuses,
        lest: filterFormik.values.lest,
        trainingCreatedBy: filterFormik.values.trainingCreatedBy,
        nutritionCreatedBy: filterFormik.values.nutritionCreatedBy,
        userTags: filterFormik.values.userTags,
        marketingTags: filterFormik.values.marketingTags,
      }).unwrap();

      const arrayUsers = [];
      let objetCompanies = {};
      setQueryMetaData({
        page: response.current_page,
        perPage: response.per_page,
        total: response.total,
        lastPage: response.last_page,
      });

      setEntries(response.per_page);
      for (let i = 0; i < response.data.length; i++) {
        objetCompanies = {
          id: response.data[i].id,
          image: response.data[i].avatar,
          name: response.data[i].name,
          email: response.data[i].email,
          phone: response.data[i].phone,
          active: response.data[i].active,
          courses: response.data[i].course_user,
          bonds: response.data[i].bonds__user,
          feesCourses: response.data[i].fees_courses,
          activeProgress: response.data[i].active_progress,
          activeProgressNutrition: response.data[i].progress_nutrition_active,

          stateFee: response.data[i].state_fee,
          stateBond: response.data[i].state_bond,

          userTags: response.data[i].tag_users,
          marketingTags: response.data[i].tag_merketing,
        };
        arrayUsers.push(objetCompanies);
      }
      setUsers(arrayUsers);
    } catch (error) {
      toasts.danger(
        "Error al obtener usuarios",
        "Por favor, inténtelo de nuevo más tarde."
      );

      console.log("Error:", error);
    }
  };

  /* 
  
  {
    "id": 228,
    "name": "alopez",
    "email": "alopez@fitmewise.com",
    "phone": null,
    "emailVerifiedAt": null,
    "emailVerifiedCommand": 0,
    "admin": 1,
    "role": "Super Admin",
    "status": 1,
    "app": 1,
    "accountStripeId": null,
    "accountPaymentMethodId": null,
    "expiresDate": null,
    "ankleDorsiflexionLeft": "2",
    "ankleDorsiflexionRight": "3",
    "lastVisited": "2023-10-13 12:48:09",
    "frecuency": null,
    "company": null,
    "occupation": null,
    "occupationDescription": "null",
    "category": "A",
    "other": null,
    "comments": null,
    "deltoidAilments": "off",
    "cervicalAilments": "off",
    "lumbarAilments": "off",
    "hipAilments": "off",
    "kneeAilments": "off",
    "ankleAilments": "off",
    "cardiorespiratory": null,
    "strength": null,
    "thoracicMobility": null,
    "squat": null,
    "selfCharging": null,
    "leg": "2",
    "isSubscriber": 0,
    "branchId": 17,
    "externalId": null,
    "externalIdJson": null,
    "externalSource": null,
    "communication": 0,
    "avatar": "https://dash.fitmewise.com/uploads/users/vjwe9xeau8.jpg",
    "isChatResponsible": 0,
    "accumulated": null,
    "createdAt": "2021-04-18T18:08:29.000000Z",
    "updatedAt": "2025-03-11T13:52:04.000000Z",
    "stripeId": null,
    "cardBrand": null,
    "cardLastFour": null,
    "trialEndsAt": null,
    "isEmailUpdating": 0,
    "objective": null,
    "hasPendingRegistration": null,
    "active": 0,
    "meetLink": null,
    "facebookToken": null,
    "signPath": null,
    "handAilments": null,
    "elbowAilments": null,
    "fileNutrition": null,
    "tagMerketing": null,
    "tagUsers": null,
    "notificationToken": "ExponentPushToken[oEk5NwDAvAxWgmG-ylGmys]",
    "allLessons": 1,
    "inactiveLastDate": "2025-04-29",
    "activeLastDate": "2025-02-07",
    "notes": null,
    "siigoClient": null,
    "scaleActive": 0,
    "permissions": [
        "multi_centro",
        "editar_usuarios",
        "access_kpi",
        "kpi.summary",
        "kpi.client_profile",
        "kpi.revenue",
        "kpi.expenses",
        "kpi.profits",
        "kpi.acquisition_and_retention",
        "kpi.utilization_and_occupancy",
        "kpi.service_evaluation",
        "kpi.training_and_nutrition_programs",
        "users.access",
        "users.list",
        "users.create_and_edit",
        "users.operational_and_financial_management",
        "users.client_retention",
        "users.client_experience",
        "users.create_users",
        "users.change_user_branch",
        "users.activate_disable_users",
        "users.assign_user_tags",
        "users.assign_marketing_tags",
        "users.reset_password",
        "users.sign_contract",
        "user_fee_management",
        "assign_fees",
        "deactivate_user",
        "pause_fee_exact_days",
        "pause_fee_period",
        "user_activity_management",
        "allow_activity_reservations",
        "user_professional_service_management",
        "edit_service_sessions",
        "enroll_user_professional_service",
        "assign_service_bonuses",
        "user_space_management",
        "assign_space_bonuses",
        "edit_space_sessions",
        "enroll_user_space_service",
        "user_store_management",
        "sell_store_products",
        "loyalty.create_tasks",
        "loyalty.view_completed_tasks",
        "loyalty.generate_incidents",
        "loyalty.edit_notes",
        "customer_experience.training_plans",
        "customer_experience.nutrition_plans",
        "customer_experience.anthropometric_and_functional_assessment",
        "customer_experience.health_and_habits_assessment",
        "branch_access.all_branches",
        "branch_access.create_edit_staff",
        "branch_access.change_staff_branch",
        "branch_access.activate_disable_staff",
        "branch_access.reset_branch_password",
        "branch_access.view_accounting_summary",
        "branch_access.view_transaction_details",
        "branch_access.delete_transactions",
        "branch_access.manage_expenses",
        "branch_access.manage_company_agreements",
        "branch_access.xml_management",
        "branch_access.create_manual_income",
        "access_store_tab",
        "sell_products_store_tab",
        "view_kpi_sales_by_staff",
        "branch_access.view_maintenance",
        "branch_access.create_maintenance",
        "branch_access.edit_maintenance",
        "branch_access.view_inventory",
        "branch_access.create_inventory",
        "branch_access.edit_inventory",
        "branch_access.delete_inventory",
        "branch_access.create_activity",
        "branch_access.edit_activities",
        "branch_access.delete_activities",
        "branch_access.view_edit_waitlist_in_activities",
        "branch_access.edit_times_in_activities",
        "branch_access.upload_calendar",
        "branch_access.edit_holidays_in_activities",
        "branch_access.create_edit_rooms_in_activities",
        "branch_access.create_professional_services",
        "branch_access.edit_professional_services",
        "branch_access.delete_professional_services",
        "branch_access.view_edit_waitlist_in_professional_services",
        "branch_access.edit_times_in_professional_services",
        "branch_access.edit_holidays_in_professional_services",
        "branch_access.create_edit_rooms_in_professional_services",
        "branch_access.create_edit_professional_service_bonuses",
        "branch_access.view_kpi_professional_service_sales_by_staff",
        "branch_access.create_spaces",
        "branch_access.edit_spaces",
        "branch_access.delete_spaces",
        "branch_access.edit_times_in_spaces",
        "branch_access.edit_holidays_in_spaces",
        "branch_access.create_edit_physical_spaces",
        "branch_access.create_edit_space_bonuses",
        "branch_access.view_kpi_space_sales_by_staff",
        "branch_access.view_courses",
        "branch_access.create_courses",
        "branch_access.edit_courses",
        "branch_access.delete_courses",
        "branch_access.view_users_courses",
        "branch_access.view_pre_recorded_classes",
        "branch_access.create_pre_recorded_classes",
        "branch_access.edit_pre_recorded_classes",
        "branch_access.delete_pre_recorded_classes",
        "branch_access.create_edit_activate_internal_chat_posts",
        "branch_access.view_fees",
        "branch_access.create_fee",
        "branch_access.edit_fee",
        "branch_access.stop_fee",
        "branch_access.create_edit_user_and_marketing_tags",
        "branch_access.contracts_clauses_customers ",
        "branch_access.taxes_receipts_customers ",
        "branch_access.customize_logo_and_colors",
        "branch_access.customize_exercise_videos",
        "branch_access.device_linking",
        "branch_access.accounting_integration",
        "branch_access.fitmewise_subscription"
    ],
    "influencerLink": "http://127.0.0.1:8000/admin/register/app/67ca66f78851d",
    "branch": {
        "id": 17,
        "gymId": 16,
        "branch": "Filial 3 DemoGym",
        "typeBranch": "entrenador_personal",
        "slug": "filial-3-demogym",
        "status": 1,
        "secretId": 0,
        "vimeoUser": "118079642",
        "vimeoId": "52f774daf4b09fbf922d33d7dadfb37438acbb7b",
        "vimeoSecret": "ihlOEvjUIn6rwiN4y7SjQJS+M81jPQpIoSG5i11V2NeNHLAyeB98MFJ1Zd+nm+9b9SYrhArkmwi6tu4OOiBuyinMgIt0EiYHq+FWdrejkhK3uKmIxYNsAxg6sGVYPmus+gcYByKUrwPaBm4G7arCv7Vjd6cTH3kzQP",
        "vimeoToken": "e2b6fa559c5e2267a9b729545aad5f4a",
        "country": "Colombia",
        "countryCode": "CO",
        "codeZip": "48764",
        "state": "Amazonas",
        "stateCode": "AMA",
        "population": "Sevilla",
        "adress": "Av. Marques de dos aguas",
        "email": "filial3@fitmewise.com",
        "web": "https://dash.fitmewise.com/download/filial-3-demogym",
        "phone": "687743034",
        "communication": 0,
        "description": "null",
        "pathFile": "uploads/lessons/675d76ca3ef47.pdf",
        "subscription": "2022-10-06",
        "externalSource": "null",
        "isChatExternal": 0,
        "isChat": 0,
        "setChatbot": null,
        "createdAt": "2022-10-06T06:36:51.000000Z",
        "updatedAt": "2025-05-04T04:14:26.000000Z",
        "stripe": 1,
        "nutrition": 1,
        "videoClass": 1,
        "appPusher": 1,
        "lesson": 1,
        "pdf": null,
        "rulePenalty": 0,
        "ruleMax": "100000",
        "firstColor": "#68478d",
        "secoundColor": "#ff0070",
        "logo": "default.png",
        "videoTutorial": "https://www.youtube.com/embed/K2Cdd3XB9vY",
        "chatbotId": 3,
        "blockNutrition": 0,
        "blockTraining": 0,
        "stripeCustomerId": null,
        "usesSubscription": 0,
        "usesBrand": 1,
        "customerToGymSubscription": 1,
        "timezone": "America/Bogota",
        "hourDifference": 7,
        "appIos": "https://apps.apple.com/es/app/fitmewise/id1531618177",
        "appAndroid": "https://play.google.com/store/apps/details?id=com.fitmewise",
        "largeLogo": "https://dash.fitmewise.com/uploads/branch_large_logo/vgq9mi951r.png",
        "contractSigning": 1,
        "contractSigningImg": "17-1.png",
        "signatureDate": "0000-00-00",
        "contractId": 1,
        "camerasModule": 0,
        "lessonModule": 1,
        "assistedModule": 1,
        "logoColorModule": 0,
        "videosModule": 0,
        "postModule": 1,
        "instagramModule": 0,
        "accessPoint": null,
        "accessModule": 1,
        "accessModuleType": 1,
        "paymentCardModule": 0,
        "trialPeriodEndDate": "2025-06-28",
        "subscriptionBlocking": 0,
        "ticketModule": 1,
        "complianceSchedule": 0,
        "setPost": 1,
        "store": 0,
        "inAppStore": 0,
        "storeModule": 0,
        "trafficLights": "[0,50,70,90]",
        "directDebitModule": 1,
        "slots": 1,
        "catchmentModule": 1,
        "recoveryModule": 1,
        "accountingModule": 1,
        "gtiCode": "5324",
        "gtiUser": "null",
        "gtiPassword": "null",
        "gtiTerminal": "null",
        "additionalVideosModule": 0,
        "cancellationAssisteds": 0,
        "cancellationLessons": 0,
        "cancellationSlots": 0,
        "contractUrl": "null",
        "gateway": null,
        "publicKeyPayment": null,
        "privateKeyPayment": null,
        "prodIntegrity": null,
        "taxAuthorities": null,
        "timeAccess": 20,
        "courseModule": 1,
        "iva": 0,
        "commentTicket": "null",
        "taxId": null,
        "fitmewiseAccessImage": "uploads/fitmewise-access-images/1736178760.jpg",
        "multiCenterQuotas": 0,
        "contractUser": null,
        "clausesUser": null,
        "daysAccess": 10,
        "assistedAnticipationDays": 0,
        "assistedTimeAccess": 0,
        "courseAnticipationDays": null,
        "courseTimeAccess": 0,
        "weightUnit": "kg",
        "measurementUnit": "cm",
        "suid": null,
        "lessonReservationHours": 0,
        "invoicePrefix": "FMW",
        "gym": {
            "id": 16,
            "gym": "DemoGym",
            "benefits": null,
            "logo": "8fehpvd5rf.png",
            "linkPrivacy": "https://fitmewise.com/politica-de-privacidad/",
            "linkTerms": "https://fitmewise.com/terminos-y-condiciones-de-uso/",
            "linkSite": "https://onelink.to/cnw4cm",
            "themeColor": null,
            "appIos": "https://apps.apple.com/es/app/fitmewise/id1531618177",
            "appAndroid": "https://play.google.com/store/apps/details?id=com.fitmewise",
            "status": 1,
            "isDeleted": 0,
            "createdAt": "2022-10-06T06:31:44.000000Z",
            "updatedAt": "2024-01-08T15:12:51.000000Z",
            "linkSubscription": null
        },
        "contract": "http://127.0.0.1:8000/null",
        "hasGymLink": false,
        "hasTrainerLink": true
    },
    "stateFee": {
        "id": 469,
        "status": "delayed",
        "statusAux": null,
        "dateFinish": "2024-08-31",
        "dateInit": null,
        "daysPause": 0,
        "method": "cash",
        "typeRecurrence": null,
        "methodAux": null,
        "userId": 228,
        "feeId": 20,
        "createdAt": "2024-08-24T21:50:30.000000Z",
        "updatedAt": "2024-11-14T14:20:49.000000Z",
        "active": 1,
        "payment": 1,
        "price": 10000,
        "priceNext": null,
        "stsId": null,
        "stsIdUnique": null,
        "txtSts": null,
        "dateSepa": null,
        "manualType": 1,
        "datePause": null,
        "main": 1,
        "feesUserId": null,
        "reasonId": null,
        "reasonUnsubscribeId": null,
        "paymentId": null,
        "registrationPaymentId": null,
        "manualComment": null,
        "deletedAt": null,
        "remaining": 0,
        "remainingAmount": null,
        "dateInitPause": null,
        "dateEndPause": null,
        "tagMarketingId": null,
        "amountDiscount": null,
        "agreementConfirm": 0,
        "transactionId": null,
        "dateFinishOriginal": null,
        "recurrence": 1,
        "discount": 0,
        "predictedUnsubscribeDate": null,
        "fee": {
            "id": 20,
            "name": "Cuota de prueba",
            "active": 1,
            "description": "Cuota",
            "price": 10000,
            "currency": "eur",
            "interval": "month",
            "intervalCount": "1",
            "trialPeriodDays": "0",
            "branchId": 17,
            "createdAt": "2023-10-31T11:08:40.000000Z",
            "updatedAt": "2024-05-20T18:24:46.000000Z",
            "stripeId": null,
            "startTime": "00:00:00",
            "endTime": "23:00:00",
            "automatedTraining": 1,
            "automatedNutrition": 1,
            "people": 1,
            "days": "Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday",
            "app": 1,
            "discount": 0,
            "repeatDiscount": 0,
            "registrationPaymentId": null,
            "datePause": null,
            "daysPause": 0,
            "centerAccess": 0,
            "dateInitPause": null,
            "dateEndPause": null
        }
    },
    "fingerprint": null,
    "feeHistory": [
        {
            "id": 683,
            "description": "fees.views.action_7",
            "userId": 228,
            "feeId": 20,
            "createdAt": "2024-08-24T21:50:31.000000Z",
            "updatedAt": "2024-08-24T21:50:31.000000Z",
            "descriptionAux": null,
            "courseFeeId": null,
            "idTransaction": null
        },
        {
            "id": 758,
            "description": "Cuota atrasada",
            "userId": 228,
            "feeId": 20,
            "createdAt": "2024-11-14T14:20:49.000000Z",
            "updatedAt": "2024-11-14T14:20:49.000000Z",
            "descriptionAux": null,
            "courseFeeId": null,
            "idTransaction": null
        }
    ],
    "bondHistory": [
        {
            "id": 85,
            "type": 1,
            "description": "fees.views.action_13",
            "userId": 228,
            "slotBondId": null,
            "bondId": 21,
            "createdAt": "2024-08-24T21:40:42.000000Z",
            "updatedAt": "2024-08-24T21:40:42.000000Z",
            "userIdOld": null,
            "code": null
        },
        {
            "id": 86,
            "type": 2,
            "description": "fees.views.action_14",
            "userId": 228,
            "slotBondId": 1,
            "bondId": null,
            "createdAt": "2024-08-24T21:50:49.000000Z",
            "updatedAt": "2024-08-24T21:50:49.000000Z",
            "userIdOld": null,
            "code": null
        },
        {
            "id": 87,
            "type": 1,
            "description": "Total de sesiones cambiado de 100 a 999",
            "userId": 228,
            "slotBondId": null,
            "bondId": 21,
            "createdAt": "2024-08-24T21:54:46.000000Z",
            "updatedAt": "2024-08-24T21:54:46.000000Z",
            "userIdOld": null,
            "code": null
        },
        {
            "id": 88,
            "type": 1,
            "description": "Total de sesiones cambiado de 999 a 0",
            "userId": 228,
            "slotBondId": null,
            "bondId": 21,
            "createdAt": "2024-08-24T21:55:08.000000Z",
            "updatedAt": "2024-08-24T21:55:08.000000Z",
            "userIdOld": null,
            "code": null
        }
    ],
    "feeNext": null,
    "roles": []
}
  
  
  */

  const token =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  const link = `${window.location.origin}/register/user?token=${token}&branch=${user?.branch?.id}`;

  useEffect(() => {
    fechtDatos();
  }, [filterFormik.values]);

  useEffect(() => {
    fechtDatos();
  }, [
    fetchUsers,
    search,
    page,
    entries,
    selectedGyms,
    selectedBranchs,
    selectedStatus,
  ]);

  const fechtCreatedUser = async (userData: any) => {
    console.log("userData para el registro", userData);
  };

  useEffect(() => {
    console.log("optionsCountryApi", optionsCountryApi);
  }, [optionsCountryApi]);

  return (
    <div className="flex flex-col items-center h-full w-full mt-8">
      <div className="w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto mb-8">
        <TableListUsers
          title={t("user.views.users")}
          description={t("user.views.users_list")}
          users={users}
          searchQuery={search}
          onSearchChange={(e) => setSearch(e.target.value)}
          handlePageChange={handlePageChange}
          handleEntriesChange={handleEntriesChange}
          entries={entries}
          queryMetaData={queryMetaData}
          isLoading={isLoading}
          selectedGyms={selectedGyms}
          setSelectedGyms={(gym) => {
            setSelectedGyms(gym);
            setgymId(gym.id);

            setSelectedBranchs(null);
          }}
          optionsGyms={optionsGyms}
          selectedBranchs={selectedBranchs}
          setSelectedBranchs={(branch) => {
            setSelectedBranchs(branch);
            setBranchId(branch?.id);
          }}
          optionsBranchs={optionsBranchs}
          selectedStatus={selectedStatus}
          setSelectedStatus={(status) => {
            setSelectedStatus(status);
          }}
          optionsStatus={optionsStatus}
          onClickFilters={handleOpenFilters}
          exportUsers={handleExportUsers}
          functionButtonCreate={() => setOpen(true)}
          functionModalQrCode={() => setOpenModalCodeQR(true)}
          functionCopyQrCode={() => {
            navigator.clipboard
              .writeText(link)
              .then(() => {
                toasts.success("Copiado", "Link copiado");
              })
              .catch(() => {
                toasts.danger("Error", "Link no copiado");
              });
          }}
          functionRegisterOneDay={() => setOpenOneDay(true)}
          handleStateUser={(user, state) => {
            changeStateUser({
              id: user,
              state,
            });
          }}
        />
      </div>
      {openFilters && branchSelected ? (
        <>
          <div className="w-full mx-auto mb-8">
            <div className="flex flex-1 self-stretch lg:gap-x-6 px-4 pb-2 border-b-2">
              <div className="fixed inset-x-4 top-16 lg:top-48 w-11/12 lg:w-11/12 z-50 flex justify-center">
                <div
                  className="fixed inset-0 bg-black opacity-50"
                  onClick={handleOpenFilters}
                ></div>
                <div className="relative bg-white w-full pt-10 rounded-md max-w-full lg:max-w-full h-full lg:h-auto max-h-[90vh] lg:max-h-[100vh] shadow-xl p-4 flex flex-col items-center overflow-y-auto md:overflow-visible">
                  <button
                    type="button"
                    className="absolute top-0 right-0 mx-4 my-2 text-gray-400 hover:text-gray-500"
                    onClick={handleOpenFilters}
                  >
                    <span className="sr-only">Close</span>
                    &times;
                  </button>
                  <form
                    action="#"
                    method="GET"
                    className="grid grid-cols-1 gap-4 md:grid-cols-4 justify-center items-center w-full"
                    onSubmit={filterFormik.handleSubmit}
                  >
                    <Select
                      name="sex"
                      tittle={t("user.views.sex")}
                      selected={optionsSex.find(
                        (gender) => gender.id === filterFormik.values.sex
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue("sex", value.id)
                      }
                      options={optionsSex}
                    />
                    <SelectCountry
                      span={t("general.mandatory")}
                      selected={optionsCountryApi.find(
                        (option) => option.id === filterFormik.values.country
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue("country", value)
                      }
                      options={optionsCountryApi}
                      tittle={t("branch.views.country")}
                    />
                    <InputWithCornerHint
                      label={t("user.views.initial_age")}
                      name="initialAge"
                      type="number"
                      value={filterFormik.values.initialAge}
                      onChange={filterFormik.handleChange}
                    />
                    <InputWithCornerHint
                      label={t("user.views.final_age")}
                      name="finalAge"
                      type="number"
                      value={filterFormik.values.finalAge}
                      onChange={filterFormik.handleChange}
                    />

                    {branchSelected.customer_to_gym_subscription ? (
                      <Select
                        name="payFee"
                        tittle={t("user.views.pay_fee")}
                        selected={optionsInfoPago.find(
                          (option) => option.id === filterFormik.values.payFee
                        )}
                        setSelected={(value) =>
                          filterFormik.setFieldValue("payFee", value.id)
                        }
                        options={optionsInfoPago}
                      />
                    ) : null}

                    {branchSelected.course_module ? (
                      <Select
                        name="payCourse"
                        tittle={t("user.views.pay_course")}
                        selected={optionsInfoPago.find(
                          (option) =>
                            option.id === filterFormik.values.payCourse
                        )}
                        setSelected={(value) =>
                          filterFormik.setFieldValue("payCourse", value.id)
                        }
                        options={optionsInfoPago}
                      />
                    ) : null}

                    <Select
                      name="multiCenter"
                      tittle={t("user.views.multi_center")}
                      selected={optionsMultiCentros.find(
                        (option) =>
                          option.id === filterFormik.values.multiCenter
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue("multiCenter", value.id)
                      }
                      options={optionsMultiCentros}
                    />

                    {branchSelected.customer_to_gym_subscription ? (
                      <>
                        <Select
                          name="cuotas"
                          tittle={t("accounting.views.cuotas")}
                          selected={optionsCoutas.find(
                            (option) => option.id === filterFormik.values.cuotas
                          )}
                          setSelected={(value) =>
                            filterFormik.setFieldValue("cuotas", value.id)
                          }
                          options={optionsCoutas}
                        />
                        <Select
                          name="feesCourses"
                          tittle={t("user.views.fees_courses")}
                          selected={optionscoutasCursos.find(
                            (option) =>
                              option.id === filterFormik.values.feesCourses
                          )}
                          setSelected={(value) =>
                            filterFormik.setFieldValue("feesCourses", value.id)
                          }
                          options={optionscoutasCursos}
                        />
                      </>
                    ) : null}
                    {branchSelected.course_module ? (
                      <>
                        <Select
                          name="courses"
                          tittle={t("course.views.courses")}
                          selected={optionsCursos.find(
                            (option) =>
                              option.id === filterFormik.values.courses
                          )}
                          setSelected={(value) =>
                            filterFormik.setFieldValue("courses", value.id)
                          }
                          options={optionsCursos}
                        />
                        <Select
                          name="bonds"
                          tittle={t(
                            "share.views.professional_service_vouchers"
                          )}
                          selected={optionsBonosSP.find(
                            (option) => option.id === filterFormik.values.bonds
                          )}
                          setSelected={(value) =>
                            filterFormik.setFieldValue("bonds", value.id)
                          }
                          options={optionsBonosSP}
                        />
                      </>
                    ) : null}

                    <Select
                      name="spaceBonuses"
                      tittle={t("share.views.space_bonuses")}
                      selected={optionsBonosEspa.find(
                        (option) =>
                          option.id === filterFormik.values.spaceBonuses
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue("spaceBonuses", value.id)
                      }
                      options={optionsBonosEspa}
                    />
                    <Select
                      name="lest"
                      tittle={t("user.views.lest")}
                      selected={optionsEval.find(
                        (option) => option.id === filterFormik.values.lest
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue("lest", value.id)
                      }
                      options={optionsEval}
                    />
                    <Select
                      name="trainingCreatedBy"
                      tittle={t("user.views.training_created_by")}
                      selected={optionTraiginCreateBy.find(
                        (option) =>
                          option.id === filterFormik.values.trainingCreatedBy
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue(
                          "trainingCreatedBy",
                          value.id
                        )
                      }
                      options={optionTraiginCreateBy}
                    />
                    <Select
                      name="nutritionCreatedBy"
                      tittle={t("user.views.nutrition_created_by")}
                      selected={optionsNutrition.find(
                        (option) =>
                          option.id === filterFormik.values.nutritionCreatedBy
                      )}
                      setSelected={(value) =>
                        filterFormik.setFieldValue(
                          "nutritionCreatedBy",
                          value.id
                        )
                      }
                      options={optionsNutrition}
                    />
                    <MultiSelect
                      title={t("brand.views.user_tags")}
                      selectedOptions={filterFormik.values.userTags}
                      setSelectedOptions={(value) =>
                        filterFormik.setFieldValue("userTags", value)
                      }
                      options={optionsUserTags}
                    />
                    <MultiSelect
                      title={t("brand.views.marketing_tags")}
                      selectedOptions={filterFormik.values.marketingTags}
                      setSelectedOptions={(value) =>
                        filterFormik.setFieldValue("marketingTags", value)
                      }
                      options={optionsMarketingTags}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* COMPONENT CREATED USER */}
      <CreateUserModal
        open={open}
        setOpen={setOpen}
        currentUserFromStore={user}
        onCreateUser={fechtCreatedUser}
        isLoadingCreate={createUserResult.isLoading || isLoading}
        rolesData={roleOptions}
        countriesData={optionsCountryApi}
        statesData={optionsStateApi}
        defaultUser={{ ...userInitialValues, branch_id: branchId }}
        gymsData={optionsGyms}
      />
      {/* END COMPONENT CREATED USER */}

      {/* FORM CREATED USER
      <Formik
        enableReinitialize
        validationSchema={userValidationSchema}
        initialValues={{
          ...userInitialValues,
          gym_id: user?.branch?.gymId,
          branch_id: user?.branch?.id,
        }}
        onSubmit={async (values, formikHelpers) => {
          const formToSend = new FormData();

          if (values.profile_avatar) {
            formToSend.append("profile_avatar", values.profile_avatar);
          }

          formToSend.append("name", values.name);
          formToSend.append("role", values.role);
          formToSend.append("phone", values.phone);
          formToSend.append("email", values.email);
          formToSend.append("address", values.address);
          formToSend.append("country", values.country);
          formToSend.append("state", values.state);
          formToSend.append("city", values.city);
          formToSend.append("postal_code", values.postal_code);
          formToSend.append("dni", values.dni);
          formToSend.append("occupation", values.occupation);
          formToSend.append(
            "occupation_description",
            values.occupation_description
          );
          formToSend.append("company", values.company);
          formToSend.append("birthday", values.birthday);
          formToSend.append("age", "0");
          formToSend.append("sex", values.sex);
          formToSend.append("objective", values.objective);
          formToSend.append("terms", values.terms.toString());
          formToSend.append("accept_clauses", values.accept_clauses.toString());
          formToSend.append(
            "sufficiently_informed",
            values.sufficiently_informed.toString()
          );
          formToSend.append(
            "receive_communications",
            values.receive_communications.toString()
          );
          formToSend.append("image_rights", values.image_rights.toString());
          formToSend.append(
            "is_chat_responsible",
            values.is_chat_responsible.toString()
          );
          formToSend.append("gym_id", values.gym_id);
          formToSend.append("branch_id", values.branch_id);

          await createUser(formToSend).unwrap();

          formikHelpers.resetForm();
          setOpen(false);
        }}
      >
        {({
          handleChange,
          setFieldValue,
          values,
          handleSubmit,
          errors,
          isValid,
          resetForm,
          touched,
        }) => {
          useEffect(() => {
            if (!isLoadingStates && !isErrorStates && states?.length > 0) {
              const statesFilterByCode = states.filter(
                (state) => state.countryCode === values.country.code
              );

              const arrayStates = statesFilterByCode.map((state) => ({
                id: state.name,
                name: state.name,
              }));
              if (arrayStates.length > 0) {
                setOptionsStateApi(arrayStates);
              } else {
                setOptionsStateApi([{ id: "NO TIENE", name: "Sin estados" }]);
              }

              // Asegúrate de que haya estados en el array antes de seleccionarlo
              if (arrayStates.length > 0 && !selectedState) {
                setSelectedState(arrayStates[0]);
              }
            }
          }, [states, isLoadingStates, isErrorStates, values.country]);

          return (
            <DialogCreate
              open={open}
              setOpen={setOpen}
              tittle={t("user.views.profile")}
              subTittle={t("user.views.info_user")}
              tittleButtonCreate={t("general.create")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={() => {

                console.log("Errores:", errors);

                handleSubmit();
              }}
              OnclickCancel={() => {
                setOpen(false);
                resetForm();
              }}
              isLoading={createUserResult.isLoading}
              //acceptDisabled={createUserResult.isLoading || !isValid}
              cancelDisabled={createUserResult.isLoading}
            >
              <div className="mt-6 mx-2">
                <div className="space-y-12">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("user.views.profil_user")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <InputFile
                          name="profile_avatar"
                          id="profile_avatar"
                          label={t("user.views.avatar")}
                          spanButton={t("user.views.avatar")}
                          description={t("user.views.avatar")}
                          selectedImage={values.profile_avatar}
                          onFileChange={(file) =>
                            setFieldValue("profile_avatar", file)
                          }
                          onRemoveImage={() =>
                            setFieldValue("profile_avatar", null)
                          }
                          tittleDelete={t("general.delete_image")}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.name")}
                          span={t("general.mandatory")}
                          id="name"
                          name="name"
                          type="text"
                          placeholder={t("user.views.name_last")}
                          value={values.name}
                          onChange={handleChange}
                          error={touched.name && !!errors.name}
                          textError={touched.name && errors.name}
                        />
                      </div>
                      <div className="col-span-full">
                        {rolesQuery.data && (
                          <Select
                            name="role"
                            span={t("general.mandatory")}
                            error={touched.role && !!errors.role}
                            textError={touched.role && errors.role}
                            selected={
                              values.role
                                ? roleOptions.find(
                                    (option) => option.id === values.role
                                  )
                                : null
                            }
                            setSelected={(value) =>
                              setFieldValue("role", value.id)
                            }
                            options={roleOptions}
                            tittle={t("user.views.role")}
                          />
                        )}
                      </div>
                      <div className="col-span-full">
                        <InputWithLeadingIcon
                          label={t("user.views.phone")}
                          span={t("general.optional")}
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder={t("user.views.phone")}
                          value={values.phone}
                          onChange={handleChange}
                          error={touched.phone && !!errors.phone}
                          textError={touched.phone && errors.phone}
                          icon={
                            <FontAwesomeIcon
                              icon={faPhone}
                              className="h-4 w-4 text-gray-400"
                            />
                          }
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithLeadingIcon
                          label={t("user.views.email")}
                          span={t("general.mandatory")}
                          id="email"
                          name="email"
                          type="email"
                          placeholder={t("user.views.email")}
                          value={values.email}
                          onChange={handleChange}
                          error={touched.email && !!errors.email}
                          textError={touched.email && errors.email}
                          icon={
                            <FontAwesomeIcon
                              icon={faAt}
                              className="h-4 w-4 text-gray-400"
                            />
                          }
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.address")}
                          span={t("general.optional")}
                          id="address"
                          name="address"
                          type="text"
                          placeholder={t("user.views.address")}
                          value={values.address}
                          onChange={handleChange}
                          error={touched.address && !!errors.address}
                          textError={touched.address && errors.address}
                        />
                      </div>
                      <div className="col-span-full">
                        <SelectCountry
                          span={t("general.optional")}
                          selected={values.country}
                          setSelected={(value) =>
                            setFieldValue("country", value)
                          }
                          options={optionsCountryApi}
                          tittle={t("user.views.country")}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          span={t("general.optional")}
                          selected={values.state}
                          setSelected={(value) => setFieldValue("state", value)}
                          options={optionsStateApi}
                          tittle={t("user.views.state")}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.city")}
                          span={t("general.optional")}
                          id="city"
                          name="city"
                          type="text"
                          placeholder={t("user.views.city")}
                          value={values.city}
                          onChange={handleChange}
                          error={touched.city && !!errors.city}
                          textError={touched.city && errors.city}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.postal_code")}
                          span={t("general.optional")}
                          id="postal_code"
                          name="postal_code"
                          type="text"
                          placeholder={t("user.views.postal_code")}
                          value={values.postal_code}
                          onChange={handleChange}
                          error={touched.postal_code && !!errors.postal_code}
                          textError={touched.postal_code && errors.postal_code}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.dni")}
                          span={t("general.optional")}
                          id="dni"
                          name="dni"
                          type="text"
                          placeholder={t("user.views.dni")}
                          value={values.dni}
                          onChange={handleChange}
                          error={touched.dni && !!errors.dni}
                          textError={touched.dni && errors.dni}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.occupation")}
                          span={t("general.optional")}
                          id="name"
                          name="occupation"
                          type="text"
                          placeholder={t("user.views.occupation")}
                          value={values.occupation}
                          onChange={handleChange}
                          error={touched.occupation && !!errors.occupation}
                          textError={touched.occupation && errors.occupation}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.business")}
                          span={t("general.optional")}
                          id="company"
                          name="company"
                          type="text"
                          placeholder={t("user.views.business")}
                          value={values.company}
                          onChange={handleChange}
                          error={touched.company && !!errors.company}
                          textError={touched.company && errors.company}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.birthday")}
                          span={t("general.mandatory")}
                          id="birthday"
                          name="birthday"
                          type="date"
                          placeholder={t("user.views.birthday")}
                          value={values.birthday}
                          onChange={handleChange}
                          error={touched.birthday && !!errors.birthday}
                          textError={touched.birthday && errors.birthday}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          name="sex"
                          span={t("general.mandatory")}
                          error={touched.sex && !!errors.sex}
                          textError={touched.sex && errors.sex}
                          selected={optionsSex.find(
                            (option) => option.id === values.sex
                          )}
                          setSelected={(value) =>
                            setFieldValue("sex", value.id)
                          }
                          options={optionsSex}
                          tittle={t("user.views.sex")}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          span={t("general.optional")}
                          selected={values.objective}
                          setSelected={(value) =>
                            setFieldValue("objective", value)
                          }
                          options={[
                            {
                              id: "healt",
                              name: t("progress.objective.healt"),
                            },
                            {
                              id: "definition",
                              name: t("progress.objective.definition"),
                            },
                            {
                              id: "hypertrophy",
                              name: t("progress.objective.hypertrophy"),
                            },
                          ]}
                          tittle={t("user.views.objective")}
                        />
                      </div>
                      <div className="col-span-full">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              checked={values.terms}
                              onChange={handleChange}
                              name="terms"
                              id="terms"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="terms"
                              className="font-medium text-gray-900 mr-2"
                            >
                              {t("user.views.accept_term")}
                            </label>
                            <a
                              href="https://fitmewise.com/terminos-y-condiciones-de-uso/"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary-600 hover:text-primary-900"
                            >
                              {t("user.views.ready_more")}
                            </a>
                          </div>
                        </div>

                        {touched.sex && !!errors.sex && (
                          <p className={`mt-1 text-sm text-red-600`}>
                            {touched.sex && errors.sex}
                          </p>
                        )}
                      </div>
                      <div className="col-span-full">
                        <Select
                          name="gym_id"
                          span={t("general.mandatory")}
                          error={touched.gym_id && !!errors.gym_id}
                          textError={touched.gym_id && errors.gym_id}
                          selected={
                            values.gym_id
                              ? optionsGyms.find(
                                  (option) => option.id === values.gym_id
                                )
                              : null
                          }
                          setSelected={(value) => {
                            setFieldValue("gym_id", value.id);
                            setgymId(value.id);
                          }}
                          options={optionsGyms}
                          tittle={t("user.views.company")}
                        />
                      </div>

                      <div className="col-span-full">
                        <Select
                          name="branch_id"
                          span={t("general.mandatory")}
                          error={touched.branch_id && !!errors.branch_id}
                          textError={touched.branch_id && errors.branch_id}
                          selected={
                            values.branch_id
                              ? optionsBranchs.find(
                                  (option) => option.id === values.branch_id
                                )
                              : null
                          }
                          setSelected={(value) =>
                            setFieldValue("branch_id", value.id)
                          }
                          options={optionsBranchs}
                          tittle={t("user.views.branch")}
                        />
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              checked={true}
                              disabled={true}
                              value={values.accept_clauses}
                              id="accept_clauses"
                              name="accept_clauses"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600 disabled:text-primary-300 cursor-not-allowed hover:cursor-not-allowed"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="accept_clauses"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.accept_clauses_norms")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              checked={true}
                              disabled={true}
                              value={values.sufficiently_informed}
                              id="sufficiently_informed"
                              name="sufficiently_informed"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600 disabled:text-primary-300 cursor-not-allowed hover:cursor-not-allowed"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="sufficiently_informed"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.informed_participation")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              checked={values.receive_communications}
                              onChange={handleChange}
                              id="receive_communications"
                              name="receive_communications"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="receive_communications"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.receive_communications")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              checked={values.image_rights}
                              onChange={handleChange}
                              id="image_rights"
                              name="image_rights"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="image_rights"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.image_rights")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          );
        }}
      </Formik>
      */}
      {/* FIN FORM CREATED USER */}

      {/* MODAL CODE QR */}
      <Modal
        open={openModalCodeQR}
        Close={() => setOpenModalCodeQR(false)}
        tittleModal={t("user.views.code_qr")}
        //textButtonCreate={t("general.create")}
        textButtonClose={t("general.cancel")}
      >
        <div className="flex flex-col gap-4">
          <div className="flex justify-center">
            {user && <QRCodeCanvas value={link} width={400} height={400} />}
          </div>
        </div>
      </Modal>
      {/* FIN MODAL CODE QR */}

      {/* FORM CREATED USER ONE DAY */}
      <Formik
        enableReinitialize
        validationSchema={userValidationSchema}
        initialValues={userInitialValues}
        onSubmit={async (values, formikHelpers) => {
          const formToSend = new FormData();

          formToSend.append("name", values.name);
          formToSend.append("phone", values.phone);
          formToSend.append("email", values.email);
          formToSend.append("dni", values.dni);
          formToSend.append("birthday", values.birthday);
          formToSend.append("age", "0");
          formToSend.append("sex", values.sex);

          /*
          formToSend.append("objective", values.objective);
          formToSend.append("terms", values.terms.toString());
          formToSend.append("accept_clauses", values.accept_clauses.toString());
          formToSend.append("sufficiently_informed", values.sufficiently_informed.toString());
          formToSend.append("receive_communications", values.receive_communications.toString());
          formToSend.append("image_rights", values.image_rights.toString());
          formToSend.append("is_chat_responsible", values.is_chat_responsible.toString());
          formToSend.append("gym_id", values.gym_id);
          formToSend.append("branch_id", values.branch_id);
          */

          await createUser(formToSend).unwrap();

          formikHelpers.resetForm();
          setOpenOneDay(false);
        }}
      >
        {({
          handleChange,
          setFieldValue,
          values,
          handleSubmit,
          errors,
          isValid,
          resetForm,
          touched,
        }) => {
          return (
            <DialogCreate
              open={openOneDay}
              setOpen={setOpenOneDay}
              tittle={t("user.views.profile")}
              subTittle={t("user.views.info_user")}
              tittleButtonCreate={t("general.create")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={() => {
                handleSubmit();
              }}
              OnclickCancel={() => {
                setOpenOneDay(false);
                resetForm();
              }}
              isLoading={createUserResult.isLoading}
              //acceptDisabled={createUserResult.isLoading || !isValid}
              cancelDisabled={createUserResult.isLoading}
            >
              <div className="mt-6 mx-2">
                <div className="space-y-12">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("user.views.profil_user")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.name")}
                          span={t("general.mandatory")}
                          id="name"
                          name="name"
                          type="text"
                          placeholder={t("user.views.name_last")}
                          value={values.name}
                          onChange={handleChange}
                          error={touched.name && !!errors.name}
                          textError={touched.name && errors.name}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithLeadingIcon
                          label={t("user.views.phone")}
                          span={t("general.optional")}
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder={t("user.views.phone")}
                          value={values.phone}
                          onChange={handleChange}
                          error={touched.phone && !!errors.phone}
                          textError={touched.phone && errors.phone}
                          icon={
                            <FontAwesomeIcon
                              icon={faPhone}
                              className="h-4 w-4 text-gray-400"
                            />
                          }
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithLeadingIcon
                          label={t("user.views.email")}
                          span={t("general.mandatory")}
                          id="email"
                          name="email"
                          type="email"
                          placeholder={t("user.views.email")}
                          value={values.email}
                          onChange={handleChange}
                          error={touched.email && !!errors.email}
                          textError={touched.email && errors.email}
                          icon={
                            <FontAwesomeIcon
                              icon={faAt}
                              className="h-4 w-4 text-gray-400"
                            />
                          }
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.dni")}
                          span={t("general.optional")}
                          id="dni"
                          name="dni"
                          type="text"
                          placeholder={t("user.views.dni")}
                          value={values.dni}
                          onChange={handleChange}
                          error={touched.dni && !!errors.dni}
                          textError={touched.dni && errors.dni}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("user.views.birthday")}
                          span={t("general.mandatory")}
                          id="birthday"
                          name="birthday"
                          type="date"
                          placeholder={t("user.views.birthday")}
                          value={values.birthday}
                          onChange={handleChange}
                          error={touched.birthday && !!errors.birthday}
                          textError={touched.birthday && errors.birthday}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          name="sex"
                          span={t("general.mandatory")}
                          error={touched.sex && !!errors.sex}
                          textError={touched.sex && errors.sex}
                          selected={optionsSex.find(
                            (option) => option.id === values.sex
                          )}
                          setSelected={(value) =>
                            setFieldValue("sex", value.id)
                          }
                          options={optionsSex}
                          tittle={t("user.views.sex")}
                        />
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              value={values?.medical_problem}
                              onChange={handleChange}
                              id="medical_problem"
                              name="medical_problem"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="medical_problem"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.medical_problem")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              value={values?.altered_tension}
                              onChange={handleChange}
                              id="altered_tension"
                              name="altered_tension"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="altered_tension"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.altered_tension")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              value={values?.amenorrea}
                              onChange={handleChange}
                              id="amenorrea"
                              name="amenorrea"
                              type="checkbox"
                              aria-describedby=""
                              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="amenorrea"
                              className="font-medium text-gray-900"
                            >
                              {t("user.views.amenorrea")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          );
        }}
      </Formik>
      {/* FIN FORM CREATED USER ONE DAY */}
    </div>
  );
};
